import Cookies from "js-cookie";

const TokenKey = "WebToken";
const UserKey = "WebUserName";
const UserEmailKey = "WebUserEmail";
const UserIdKey = "WebUserId";
const AvatarKey = "avatar";
const AssetsKey = "assets";
const rechargeTypeKey = "rechargeType";
const RemarkKey = "Remark";

function removeLocalStorageValue(key) {
  localStorage.removeItem(key);
}

function dispatchAuthCleared() {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }

  if (typeof Event === 'function') {
    window.dispatchEvent(new Event('auth:cleared'));
    return;
  }

  if (typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    const event = document.createEvent('Event');
    event.initEvent('auth:cleared', false, false);
    window.dispatchEvent(event);
  }
}

export function clearAuthIdentity() {
  removeLocalStorageValue(UserKey);
  removeLocalStorageValue(UserEmailKey);
  removeLocalStorageValue(UserIdKey);
  removeLocalStorageValue(AvatarKey);
  removeLocalStorageValue(AssetsKey);
  removeLocalStorageValue(RemarkKey);
}

export function getToken() {
  return localStorage.getItem(TokenKey)
}
export function setToken(token) {
  localStorage.setItem(TokenKey, token);
}
export function removeToken() {
  removeLocalStorageValue(TokenKey);
  clearAuthIdentity();
  dispatchAuthCleared();
}

export function getUser() {
  return localStorage.getItem(UserKey);
}
export function setUser(user) {
  localStorage.setItem(UserKey, user);
}

export function getUserEmail() {
  return localStorage.getItem(UserEmailKey);
}
export function setUserEmail(email) {
  const value = email === null || email === undefined ? '' : String(email).trim()
  if (value) {
    localStorage.setItem(UserEmailKey, value);
  } else {
    localStorage.removeItem(UserEmailKey);
  }
}

// 获取备注
export function getRemark() {
  return localStorage.getItem(RemarkKey);
}
export function setRemark(remark) {
  localStorage.setItem(RemarkKey, remark);
}

export function getUserId() {
  return localStorage.getItem(UserIdKey)
}
export function setUserId(id) {
  localStorage.setItem(UserIdKey, id);
}
export function setUserAvatar(avatar) {
  localStorage.setItem(AvatarKey, avatar);
}
export function getAssets() {
  return localStorage.getItem(AssetsKey)
}
export function setAssets(assets) {
  localStorage.setItem(AssetsKey, assets);
}

export function getRechargeType() {
  return localStorage.getItem(rechargeTypeKey)
}
export function setRechargeType(type) {
  localStorage.setItem(rechargeTypeKey, type);
}
export function removeRechargeType() {
  localStorage.removeItem(rechargeTypeKey);
}
